import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import MainPage from "src/components/Page/MainPage";
import { onSuccessClickFormBasicForm } from "src/helpers/onSuccess";
import { useAppDispatch } from "src/store";
import {
  deleteClientCancellationReasonSaga,
  getClientCancellationReasonDetailsSaga,
  getClientCancellationReasonListSaga,
} from "src/store/clientcancelreason/saga";
import {
  ClientCancellationReasonDetailDto,
  ClientCancellationReasonDto,
} from "src/store/clientcancelreason/type";
import ClientCancellationReasonCreateForm from "./create";
import ClientCancellationReasonEditForm from "./edit";
const ClientCancellationReasonPage = () => {
  const { t } = useTranslation();
  const dispatch = useAppDispatch();
  const [data, setData] = useState<ClientCancellationReasonDto[]>([]);
  const [showCreate, setShowCreate] = useState(false);
  const [showEdit, setShowEdit] = useState(false);
  const [selected, setSelected] = useState<ClientCancellationReasonDetailDto>();
  const columns = [
    {
      text: t("ClientCancellationReason.Content"),
      dataField: "Content",
    },
  ];

  return (
    <React.Fragment>
      <MainPage
        title={t("ClientCancellationReason.PageTitle")}
        metaTag={t("ClientCancellationReason.MetaTag")}
        gridProps={{
          addTitle: t("ClientCancellationReason.AddButton").toString(),
          listData: data,
          columns: columns,
          setDataList: setData,
          action: getClientCancellationReasonListSaga,
          onCreateClick: () => setShowCreate(true),
          editButton: {
            onClick: (id, data) => {
              dispatch(
                getClientCancellationReasonDetailsSaga({
                  payload: {
                    onSuccess: (message, payload, response) => {
                      let currenctObject = payload;
                      currenctObject.Translates = response.Translates;
                      setSelected(currenctObject);
                      return setShowEdit(true);
                    },
                    onError: () => {},
                  },
                  id: id,
                })
              );
            },
          },
          deleteButton: {
            text: (id, data: ClientCancellationReasonDto) =>
              t("ClientCancellationReason.DeleteQA", {
                name: data.Content,
              }),
            action: deleteClientCancellationReasonSaga,
            onClick: (id, data) => setShowEdit(data),
          },
        }}
      />
      <ClientCancellationReasonCreateForm
        open={showCreate}
        onHide={() => setShowCreate(false)}
        onSuccessClick={(m) =>
          onSuccessClickFormBasicForm({
            dispatch: dispatch,
            message: m,
            action: getClientCancellationReasonListSaga,
            setDataList: setData,
          })
        }
      />
      {selected && (
        <ClientCancellationReasonEditForm
          data={selected}
          open={showEdit}
          onHide={() => {
            setShowEdit(false);
            return setSelected(undefined);
          }}
          onSuccessClick={(m) =>
            onSuccessClickFormBasicForm({
              dispatch: dispatch,
              message: m,
              action: getClientCancellationReasonListSaga,
              setDataList: setData,
            })
          }
        />
      )}
    </React.Fragment>
  );
};

export default ClientCancellationReasonPage;
